import axios from "axios";

const API_BASE_URL =
  "https://docker-compose-dev-primepersonacreator-83cd036b.koyeb.app";

//const API_BASE_URL = "http://localhost:8000";

export const retryApiCall = async (apiFunction, args = [], retries = 3) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const result = await apiFunction(...args);
      return result;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 500 &&
        attempt < retries
      ) {
        console.log(`Retrying... (${attempt}/${retries})`);
      } else {
        throw error;
      }
    }
  }
};

export const getDatasets = async (sectorId, location) => {
  try {
    const params = [];
    sectorId.forEach((item) => {
      params.push(`sector_id=${item}`);
    });
    const string = params.join("&");
    const response = await axios.get(
      `${API_BASE_URL}/getdatasets?location=${location}&${string}`
    );
    return response.data.response;
  } catch (error) {
    throw new Error("Error fetching datasets");
  }
};

export const getSectors = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/getsectors`);
    return response.data.response;
  } catch (error) {
    throw new Error("Error fetching sectors");
  }
};

export const getQuestions = async (datasetId, sectorId) => {
  try {
    const params = [];
    sectorId.forEach((item) => {
      params.push(`sector_ids=${item}`);
    });
    const string = params.join("&");
    const response = await axios.get(
      `${API_BASE_URL}/getquestions?dataset_id=${datasetId}&${string}`
    );
    return response.data.response;
  } catch (error) {
    throw new Error("Error fetching questions");
  }
};

export const getEthnicities = async (datasetName, datasetPath) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/getethnicity?dataset=${datasetName}&dataset_path=${encodeURIComponent(
        datasetPath
      )}`
    );
    return response.data.response;
  } catch (error) {
    throw new Error("Error fetching ethnicities");
  }
};

export const getLocations = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/getlocations`);
    return response.data.response;
  } catch (error) {
    throw new Error("Error fetching locations");
  }
};

export const createPersona = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/persona`, data);
    return response.data;
  } catch (error) {
    throw new Error("Error creating persona");
  }
};
